export const urlBackendProd: string = 'https://api.i-food.me';
export const urlBackendTest: string = 'https://cowbird-wanted-dory.ngrok-free.app:443';
export const urlLocalTestBackend: string = 'http://localhost:8000';

export const MAIN_FRONTEND_ORIGINS: string[] = [
    'https://i-food.me',
    'https://ps.i-food.me',
    'https://tg-mini-app-ct1.pages.dev',
];

export const TEST_FRONTEND_ORIGINS: string[] = [
    'https://test.tg-mini-app-ct1.pages.dev',
    'https://partner-space.pages.dev',
    'https://test.partner-space.pages.dev',
    'https://test.ifoodme.pages.dev',
];

const BACKEND_OVERRIDE_QUERY_PARAM = 'backend';
const PROD_BACKEND_OVERRIDE_VALUE = 'prod';

export function isLocalFrontendHost(hostname: string): boolean {
    const normalizedHostname = hostname.toLowerCase();
    return normalizedHostname === 'localhost' || normalizedHostname === '127.0.0.1';
}

export function isTestFrontendOrigin(origin: string): boolean {
    return TEST_FRONTEND_ORIGINS.includes(origin);
}

export function isPartnerPersonalDomain(origin: string, hostname: string): boolean {
    const normalizedHostname = hostname.toLowerCase();
    return !isLocalFrontendHost(normalizedHostname)
        && !MAIN_FRONTEND_ORIGINS.includes(origin)
        && !TEST_FRONTEND_ORIGINS.includes(origin);
}

export function shouldUseProdBackendOverride(origin: string, search: string): boolean {
    if (!isTestFrontendOrigin(origin)) {
        return false;
    }

    const queryParams = new URLSearchParams(search);
    return (queryParams.get(BACKEND_OVERRIDE_QUERY_PARAM) ?? '').toLowerCase() === PROD_BACKEND_OVERRIDE_VALUE;
}

export function resolveBackendUrlForOrigin(origin: string, hostname: string, search: string): string {
    if (isLocalFrontendHost(hostname)) {
        return urlLocalTestBackend;
    }

    if (isTestFrontendOrigin(origin)) {
        return shouldUseProdBackendOverride(origin, search) ? urlBackendProd : urlBackendTest;
    }

    return urlBackendProd;
}

export function canSwitchTestOriginToProdBackend(origin: string, selectedBackendUrl: string): boolean {
    return isTestFrontendOrigin(origin) && selectedBackendUrl === urlBackendTest;
}

export function buildProdBackendOverrideUrl(currentHref: string): string {
    const nextUrl = new URL(currentHref);
    nextUrl.searchParams.set(BACKEND_OVERRIDE_QUERY_PARAM, PROD_BACKEND_OVERRIDE_VALUE);
    return nextUrl.toString();
}

/**
 * The production override is a one-load handoff from the test spinner. Removing
 * it after startup keeps the current page on production while ensuring a normal
 * browser reload returns the test frontend to its test backend.
 */
export function removeBackendOverrideFromUrl(currentHref: string): string {
    const nextUrl = new URL(currentHref);
    nextUrl.searchParams.delete(BACKEND_OVERRIDE_QUERY_PARAM);
    return nextUrl.toString();
}
